import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TextClip} from 'storyboard-renderer';
import {FontService} from "../shared/font.service";
import {Font} from "storyboard-renderer";

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnInit {

  @Input() clip;

  colorToggle = false;
  bgColorToggle = false;
  fontBgColorToggle = false;
  transparentBackgroundColor = 'rgb(223,230,235)';

  constructor(public fontService: FontService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  cpToggleChange(open: boolean) {
    this.colorToggle = open;
  }

  changeClipBackgroundColor(event) {
    this.clip.background_color_opacity = this.getOpacity(event);
  }

  finishTextEditing(applyForAll = false) {
    this.activeModal.close({clip: this.clip, applyForAll: applyForAll});
  }

  getStyle(font: Font){
    let ret = font.getStyle();
    ret['font-size'] = parseInt(ret['font-size'], 10) / 2 + "px";
    /**
     * the font itself has a background color,
     * but for the background color of the editable div we want to use the textClip's background instead
     */
    ret['background-color'] = this.clip.background_color_opacity == 0 ? this.transparentBackgroundColor : this.clip.getBackgroundColorRgba();
    return ret;
  }

  getOpacity(value) {
    const rgbaColor = Font.hexToRgb(value);
    return (rgbaColor && rgbaColor.a !== null) ? rgbaColor.a : 1;
  }

  getWeightName() {
    for (let weight of this.fontService.getWeightsByFamily(this.clip.font.font_family)) {
      if (weight.weight == this.clip.font.font_weight) {
        return weight.title;
      }
    }
    return '';
  }

  lockToggle(clip: TextClip) {
    clip.unlocked = !clip.unlocked;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/text-editor/text-editor.component.ts